import { FormItem as BaseFormItem, FormControl, FormDescription, FormLabel, FormMessage } from "uiShadcn/form";
import RequiredIndicator from "ui/RequiredIndicator/RequiredIndicator";
import { cn } from "utils/helpers/cn";

interface FormItemProps {
    label?: string;
    description?: string;
    children?: React.ReactNode;
    required?: boolean;
    extraContent?: React.ReactNode;
    labelClassName?: string;
    belowControl?: React.ReactNode;
}

export default function FormItem({
    description,
    label,
    children,
    required,
    extraContent,
    labelClassName,
    belowControl,
}: FormItemProps) {
    return (
        <BaseFormItem className="flex w-full flex-col gap-n2">
            {label && (
                <FormLabel className={cn("flex items-center gap-1 leading-5", labelClassName)}>
                    {label} {extraContent} {required && <RequiredIndicator />}
                </FormLabel>
            )}
            <FormControl>{children}</FormControl>
            {belowControl}
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
        </BaseFormItem>
    );
}
